<div class="text-danger">
  <mat-icon class="icon">error</mat-icon>

  <p class="error-message" [innerHTML]="text"></p>
</div>
